const locale = {
  'c.ModifyPassword.title': 'تغيير كلمة المرور',

  'c.ModifyPassword.label.oldPassword': 'كلمة المرور القديمة',
  'c.ModifyPassword.placeholder.oldPassword': 'الرجاء إدخال كلمة المرور القديمة',

  'c.ModifyPassword.label.newPassword': 'كلمة المرور الجديدة',
  'c.ModifyPassword.placeholder.newPassword': '8-26 حرفا (يجب أن تتضمن حروف كبيرة وصغيرة ورقم)',
  'c.ModifyPassword.rule.newPassword.min': 'لا يمكن أن تكون طول كلمة المرور أقل من 8 أحرف!',
  'c.ModifyPassword.rule.newPassword.repeat':
    'لا يمكن أن تكون كلمة المرور الجديدة هي نفس كلمة المرور القديمة!',

  'c.ModifyPassword.label.confirmPassword': 'تأكيد كلمة المرور',
  'c.ModifyPassword.placeholder.confirmPassword': 'الرجاء تأكيد كلمة المرور الجديدة مرة أخرى',
  'c.ModifyPassword.rule.confirmPassword.inconsistent': 'المدخلات لم تتطابق في كلمتي المرور!',

  'c.ModifyPassword.button.submit': 'حفظ',

  'c.ModifyPassword.request.loading': 'جاري تغيير كلمة المرور...',
  'c.ModifyPassword.request.success': 'تم تغيير كلمة المرور بنجاح. الرجاء تسجيل الدخول مرة أخرى.',
  'c.ModifyPassword.request.error': 'فشل تغيير كلمة المرور! الرجاء المحاولة مرة أخرى في وقت لاحق.',
};
export default locale;
